import { Button, Icon, Text } from '@chakra-ui/react';
import CustomDesignGuideIcon from '../../../theme/icons/CustomDesignGuideIcon';

interface DesignGuideButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const DesignGuideButton = ({ onClick, disabled }: DesignGuideButtonProps) => (
  <Button
    variant="gradientOutline"
    flexShrink={0}
    onClick={onClick}
    disabled={disabled}
  >
    <Icon as={CustomDesignGuideIcon} width="16px" height="20px" />
    <Text
      ml={2}
      bg="linear-gradient(180deg, #FF9554 16.5%, #FF4935 100%)"
      bgClip="text"
      color="transparent"
    >
      Design Guide
    </Text>
  </Button>
);

export default DesignGuideButton;
